import Vue from 'www/vue_components'
import { createPinia, PiniaVuePlugin } from 'pinia'
import vuetify from 'www/modules/vuetify-plugin'
import PartnersAnalysesCardsList from 'www/vue_components/common/Analyses/pages/AnalysesListPage/PartnersAnalysesCardsList.vue'

const mountNode = document.getElementById('partners-analyses-cards-list')

if (mountNode) {
  Vue.use(PiniaVuePlugin)

  new Vue({
    vuetify,
    el: mountNode,
    name: 'PartnersAnalysesCardsListRoot',
    pinia: createPinia(),
    components: {
      PartnersAnalysesCardsList,
    },
  })
}
